<template>
  <div>
    <div class="login">
      <div class="accountLogin">账号登录</div>
      <div class="input">
        <el-input type="tel" v-model="phone" placeholder="手机号"></el-input>
      </div>
      <div class="input">
        <el-input type="password" v-model="password" placeholder="密码"></el-input>
      </div>
      <div class="forget">
        <!-- <el-checkbox v-model="isHoldWeek">保持一周登录状态</el-checkbox> -->
        <div class="forgetPwd" @click="forgetPassword">忘记密码？</div>
      </div>
      <div class="loginBtn" @click="login">登录</div>
    </div>
    <div class="rigster" @click="toRegister">
      <div class="huiyuan"></div>
      还没有账号？立即注册
    </div>
  </div>
</template>

<script>
import { loginAPI } from "@/api/index";
export default {
  data() {
    return {
      phone: "",
      password: "",
      // isHoldWeek: false,
    };
  },
  mounted() {
    // this.checkInfo();
  },
  methods: {
    async checkInfo() {
      let date = new Date().getTime();
      let loginInfo = localStorage.getItem("loginInfo");
      if (!loginInfo) {
        return;
      }
      if (loginInfo.saveTime == -1) {
        localStorage.removeItem("loginInfo");
      } else {
        if (date > loginInfo.saveTime) {
          localStorage.removeItem("loginInfo");
        } else {
          this.$router.push("/");
        }
      }
    },
    async login() {
      await loginAPI({
        phone: this.phone,
        password: this.password,
      }).then((res) => {
        this.$message.success(res.data.msg);
        localStorage.setItem("token", res.data.data.token);
        setTimeout(() => {
          this.phone = "";
          this.password = "";
          this.$router.push("/");
        });
      });
    },
    forgetPassword() {
      this.$router.push({ path: "/forgetPassword" });
    },
    toRegister() {
      this.$emit("changeType", 2);
    },
  },
};
</script>

<style lang="less" scoped>
.login {
  width: 400px;
  // height: 296px;
  padding: 20px 30px;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 5px;

  .accountLogin {
    width: 60px;
    height: 52px;
    line-height: 52px;
    text-align: left;
    margin-bottom: 20px;
    font-family: PingFangSC-Regular, sans-serif;
    border-bottom: 2px solid #409eff;
  }

  ::v-deep .el-input__inner {
    border: none !important;
  }

  ::v-deep .el-input__inner {
    background-color: transparent !important;
    color: #1a1a1a !important;
    border: none;
    padding: 0;
  }

  ::v-deep .el-input__inner::placeholder {
    color: #1a1a1a;
  }

  .input {
    margin-bottom: 20px;
    position: relative;
  }

  .el-input:hover::before {
    background: #ccc;
    content: "";
    position: absolute;
    width: 100%;
    height: 1px;
    left: 0;
    bottom: 0;
  }

  .forget {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .forgetPwd {
      color: #8590a6;
      cursor: pointer;
      transition: all 0.3s linear 0s;
    }

    .forgetPwd:hover {
      color: inherit;
    }
  }

  .loginBtn {
    width: 340px;
    height: 60px;
    margin: 20px auto 0;
    background: #409eff;
    color: #fff;
    cursor: pointer;
    line-height: 60px;
    border-radius: 5px;
    font-size: 16px;
    text-align: center;
    transition: all 0.3s linear 0s;
  }
  .loginBtn:hover {
    opacity: 0.7;
  }
}

.rigster {
  line-height: 60px;
  height: 60px;
  width: 400px;
  border-radius: 5px;
  font-size: 16px;
  text-align: center;
  margin: 30px auto 0;
  transition: all 0.3s linear 0s;
  background: #409eff;
  color: #fff;
  cursor: pointer;

  .huiyuan {
    width: 16px;
    height: 18px;
    display: inline-block;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-image: url("../../../../static/huiyuan.png");
    vertical-align: middle;
    margin-right: 5px;
  }
}

.rigster:hover {
  opacity: 0.7;
}
</style>
